import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Input, message } from 'antd';
import { graphql, compose } from 'react-apollo';

import MUTATION from '../graphql/mutations/newRetainerClientAssignmentActivityMutation.graphql';

const FormItem = Form.Item;
const { TextArea } = Input;

class NewRetainerClientAssignmentActivityForm extends Component {
  state = {
    submittingForm: false,
  };

  handleOk = () => {
    this.setState({
      submittingForm: true,
    });
    const { form, closeModal, mutate, retainerClientAssignmentId } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        mutate({ variables: { retainerClientAssignmentId, ...values } })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            form.resetFields();
            message.success('Activity added!');
            closeModal();
          })
          .catch((err1) => {
            this.setState({
              submittingForm: false,
            });
            console.log(err1);
            message.error(err1.message);
          });
      } else {
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { submittingForm } = this.state;
    const { form, retainerClientAssignmentId, closeModal } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Modal
        title="Create new activity"
        visible={!!retainerClientAssignmentId}
        onOk={this.handleOk}
        onCancel={closeModal}
      >
        <FormItem label="Activity" hasFeedback>
          {getFieldDecorator('activity', {
            rules: [{ required: true, message: 'Field is required!' }],
          })(<TextArea disabled={submittingForm} autosize={{ minRows: 2, maxRows: 6 }} />)}
        </FormItem>
      </Modal>
    );
  }
}

NewRetainerClientAssignmentActivityForm.propTypes = {
  retainerClientAssignmentId: PropTypes.number,
  closeModal: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  mutate: PropTypes.func.isRequired,
};

NewRetainerClientAssignmentActivityForm.defaultProps = {
  retainerClientAssignmentId: null,
};

export default compose(
  graphql(MUTATION),
  Form.create(),
)(NewRetainerClientAssignmentActivityForm);



// WEBPACK FOOTER //
// ./src/forms/NewRetainerClientAssignmentActivityForm.jsx